import cloneDeep from 'lodash/cloneDeep';
import type {Schema} from 'schemaDefinition/types';
import type {SchemaMode} from 'schemas/types';
import {visitSchemaParts} from 'schemaDefinition';

/**
 * Make some parts readonly if schemaMode is 'dialog', since right panel
 * for editing of value is not available in dialog mode
 */
export const getSchemaForMode = (
  schema: Schema,
  schemaMode: SchemaMode,
): Schema => {
  if (schemaMode === 'full') {
    return schema;
  }

  const clonedSchema = cloneDeep(schema);
  visitSchemaParts(clonedSchema, part => {
    if (
      part.type === 'linkedAgent' ||
      part.type === 'linkedLiterary' ||
      part.type === 'thesaurus'
    ) {
      part.readonly = true;
    }
  });
  return clonedSchema;
};
